import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, Input, Upload, Select, Divider } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import menuConfigurationActions from "../../../../redux/menuConfiguration/actions";
import { uploadImage } from "../../../../utils/utility";
import "./index.css";

const MenuConfigurationTagsEditModal = ({
  openTagsEditModal,
  setOpenTagsEditModal,
  record,
  setRecord,
}) => {
  const dispatch = useDispatch();
  const [name, setName] = useState("");
  const [languages, setLanguages] = useState([]);
  const [icon, setIcon] = useState("");
  const [typeId, setTypeId] = useState("");
  const { editTag } = menuConfigurationActions;
  const { menuConfiguration } = useSelector(
    (state) => state.organizationsReducer
  );
  const organizationId = Number(localStorage.getItem("organizationId"));
  const defaultLanguage = menuConfiguration?.defaultLanguage;
  const organizationLanguages = menuConfiguration?.languages;

  useEffect(() => {
    const mergedLanguageArray = organizationLanguages
      ?.map((item) => {
        const existingItem = record?.languages?.find(
          (entry) => entry.abbreviation === item
        );
        if (existingItem) {
          return existingItem;
        } else {
          return { abbreviation: item, value: "" };
        }
      })
      ?.sort((a, b) => {
        if (a.abbreviation === defaultLanguage) {
          return -1;
        }
        if (b.abbreviation === defaultLanguage) {
          return 1;
        }
        return 0;
      });
    setName(record.name);
    setLanguages(mergedLanguageArray || []);
    setIcon(record.icon);
    setTypeId(record.typeId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record, openTagsEditModal]);

  const handleGetLangInput = (e, index) => {
    const updatedLanguages = [...languages];
    updatedLanguages[index] = {
      ...updatedLanguages[index],
      value: e.target.value,
    };
    setLanguages(updatedLanguages);
  };

  const editInputsUI = Object.keys(languages)?.map((lang) => {
    const langObj = languages[lang];
    return (
      <div
        className="menu-configuration-tags-edit-modal-inputs-container"
        key={lang}
      >
        <Input
          addonBefore={langObj.abbreviation?.toUpperCase()}
          className="menu-configuration-tags-edit-modal-input"
          value={langObj.value || ""}
          onChange={(e) => handleGetLangInput(e, lang)}
        />
      </div>
    );
  });

  const closeTagsEditModal = () => {
    setOpenTagsEditModal(false);
    setRecord({});
  };

  const editTags = () => {
    const editTagBody = {
      tag: {
        typeId,
        tagId: record.tagId,
        name,
        languages,
        icon: icon?.substring(icon?.indexOf(",") + 1),
      },
      organizationId,
    };
    dispatch(editTag(editTagBody));
    setOpenTagsEditModal(false);
  };

  const tagsTypeSelectArray = [
    { value: 2, label: "горе дясно" },
    { value: 4, label: "долу дясно" },
    { value: 1, label: "горе ляво" },
    { value: 3, label: "долу ляво" },
  ];

  const handleChange = (value) => {
    setTypeId(value);
  };

  return (
    <Modal
      centered
      width={window.innerWidth > 600 ? "33rem" : "80%"}
      open={openTagsEditModal}
      onCancel={closeTagsEditModal}
      footer={null}
    >
      <div className="menu-configuration-edit-modal-main-container">
        <div>
          <h4 className="menu-configuration-tags-edit-modal-headings">
            Език / Име
          </h4>
          <div>{editInputsUI}</div>
        </div>
        <div>
          <Divider
            type={window.innerWidth > 600 ? "vertical" : "horizontal"}
            className="menu-configuration-edit-modal-divider"
          />
        </div>
        <div>
          <h4 className="menu-configuration-tags-edit-modal-headings">Тип</h4>
          <Select
            className="menu-configuration-tags-edit-modal-type-select"
            value={typeId}
            onChange={handleChange}
            options={tagsTypeSelectArray}
          />

          <div className="menu-configuration-tags-image-section">
            {icon !== undefined && (
              <img
                src={`data:image/jpeg;base64,${icon?.substring(
                  icon?.indexOf(",") + 1
                )}`}
                className="menu-configuration-edit-uploaded-image"
                alt="icon"
              />
            )}
            <Upload
              showUploadList={false}
              onChange={(e) => uploadImage(e, setIcon)}
              accept="image/png,image/jpeg,image/webp"
              beforeUpload={() => false}
            >
              <Button
                ghost
                type="primary"
                className="menu-configuration-edit-tags-upload-button"
                icon={<UploadOutlined />}
              >
                Качи файл
              </Button>
            </Upload>
          </div>
        </div>
      </div>
      <div className="menu-configuration-edit-action-buttons-section">
        <Button
          className="menu-configuration-edit-action-button"
          onClick={closeTagsEditModal}
        >
          Затвори
        </Button>
        <Button
          className="menu-configuration-edit-action-button"
          type="primary"
          onClick={editTags}
        >
          Запази
        </Button>
      </div>
    </Modal>
  );
};

export default MenuConfigurationTagsEditModal;
